import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import BasketSettings from "./BasketSettings";
import BasketDataSettings from "./BasketDataSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const WidgetShoppingBasket = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <BasketSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="3">
            <BasketDataSettings {...props} />
         </TabPane>
      </Tabs>
   );
};
export default WidgetShoppingBasket;
